import { Modal } from 'antd'
import React, { FC } from 'react'
import DownloadQrImage from './DownloadQrImage'
import QrExpiryNotice from './QrExpiryNotice'

interface IProps {
  img?: string
  isModalOpen: boolean
  expiresAtMs?: number
  isSkipSelectBill?: boolean
  setIsModalOpen: (value: boolean) => void
}

const ModalSHB: FC<IProps> = ({ isModalOpen, img, setIsModalOpen, expiresAtMs }: IProps) => {
  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <Modal
        title={<></>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={<></>}
        className="p-0 custom-modal rouder-31"
      >
        <div className="relative bg-white rounded-[30px] pt-4">
          <img src={`data:image/png;base64, ${img}`} alt="" className="mx-auto w-full" />
          <DownloadQrImage imageSrc={img} fileName="shb-qr-thanh-toan.png" />
          <QrExpiryNotice
            isModalOpen={isModalOpen && !!img}
            paymentChannel="SHB"
            resetKey={img}
            expiresAtMs={expiresAtMs}
          />
        </div>
      </Modal>
    </>
  )
}
export default ModalSHB
